import { Link } from 'react-router-dom';
import Screen from '../demo/Screen';
import './NotFound.css';

export default function NotFound() {
  return (
    <Screen id="not-found" title="Page not found" className="not-found">
      <p className="eyebrow">404</p>
      <h1 className="headline">Page not found</h1>
      <p className="lede">This page is not part of the walkthrough.</p>
      <Link to="/" className="btn btn--primary" data-trapezium-id="not-found.go-home">
        Go to the start
      </Link>
    </Screen>
  );
}
